import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["location", "roomType"]
  static values = {
    roomTypes: Array,
    locations: Array,
    blankLocationLabel: String,
    blankRoomTypeLabel: String
  }

  connect() {
    this.rebuildLocationOptions()
    this.rebuildRoomTypeOptions()
  }

  locationChanged() {
    this.locationTarget.dataset.savedId = this.locationTarget.value
    this.rebuildRoomTypeOptions(true)
  }

  roomTypeChanged() {
    this.roomTypeTarget.dataset.savedId = this.roomTypeTarget.value
    this.rebuildLocationOptions(true)
  }

  savedId(select) {
    const saved = select.dataset.savedId
    if (saved != null && saved !== "") return String(saved)
    return String(select.value || "")
  }

  rebuildLocationOptions(resetInvalid = false) {
    const roomTypeId = this.savedId(this.roomTypeTarget)
    const previous = this.savedId(this.locationTarget)
    let locations = this.locationsValue

    if (roomTypeId) {
      locations = locations.filter((location) =>
        location.room_type_ids.map(String).includes(roomTypeId)
      )
    }

    this.fillSelect(
      this.locationTarget,
      locations,
      previous,
      resetInvalid,
      this.blankLocationLabelValue
    )
  }

  rebuildRoomTypeOptions(resetInvalid = false) {
    const locationId = this.savedId(this.locationTarget)
    const previous = this.savedId(this.roomTypeTarget)
    let roomTypes = this.roomTypesValue

    if (locationId) {
      roomTypes = roomTypes.filter((roomType) =>
        roomType.location_ids.map(String).includes(locationId)
      )
    }

    this.fillSelect(
      this.roomTypeTarget,
      roomTypes,
      previous,
      resetInvalid,
      this.blankRoomTypeLabelValue
    )
  }

  fillSelect(select, items, previous, resetInvalid, blankLabel) {
    select.replaceChildren()

    const blankOption = document.createElement("option")
    blankOption.value = ""
    blankOption.textContent = blankLabel
    select.appendChild(blankOption)

    items.forEach((item) => {
      const option = document.createElement("option")
      option.value = String(item.id)
      option.textContent = item.name
      select.appendChild(option)
    })

    const validValues = ["", ...items.map((item) => String(item.id))]
    if (validValues.includes(previous)) {
      select.value = previous
      select.dataset.savedId = previous
    } else if (resetInvalid) {
      select.value = ""
      select.dataset.savedId = ""
    }
  }
}
